@if (closingReason()) {
  <dl class="form-field">
    <dt class="field-label">Closing Reason</dt>
    <dd class="field-value-readonly" aut-id="closing-reason-display">{{ closingReason() }}</dd>
  </dl>
}
@if (closingNotes()) {
  <dl class="form-field">
    <dt class="field-label">Closing Notes</dt>
    <dd class="field-value-readonly field-value-readonly--multiline" aut-id="closing-notes-display">{{ closingNotes() }}</dd>
  </dl>
}
